import React from "react";
import { CircularProgress, Modal } from "@mui/material";
import ModalBox from "../../../../common/ModalBox";
import styled from "@emotion/styled";

import AnonymizeModal from "./M_Anonymize";
import BanCodeModal from "./M_BanCode";
import BanCompetitorsModal from "./M_BanCompetitors";
import BanSubstringsModal from "./M_BanSubstrings";
import BanTopicsModal from "./M_BanTopics";
import CodeModal from "./M_Code";
import GibberishModal from "./M_Gibberish";
import InvisibleTextModal from "./M_InvisibleText";
import LanguageModal from "./M_Language";
import PromptInjectionModal from "./M_PromptInjection";
import RegexModal from "./M_Regex";
import SecretsModal from "./M_Secrets";
import SentimentModal from "./M_Sentiment";
import TokenLimitModal from "./M_TokenLimit";
import ToxicityModal from "./M_Toxicity";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 400px;
`;

function EditPromptScannerModal({ open, handleClose, zoneUid, currentKey }) {
  if (currentKey === "anonymize") {
    return <AnonymizeModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "ban_code") {
    return <BanCodeModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "ban_competitors") {
    return <BanCompetitorsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "ban_substrings") {
    return <BanSubstringsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "ban_topics") {
    return <BanTopicsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "code") {
    return <CodeModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "gibberish") {
    return <GibberishModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "invisible_text") {
    return <InvisibleTextModal open={open} handleClose={handleClose} />;
  } else if (currentKey === "language") {
    return <LanguageModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "prompt_injection") {
    return <PromptInjectionModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "regex") {
    return <RegexModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "secrets") {
    return <SecretsModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "sentiment") {
    return <SentimentModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "token_limit") {
    return <TokenLimitModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else if (currentKey === "toxicity") {
    return <ToxicityModal open={open} handleClose={handleClose} zoneUid={zoneUid} />;
  } else {
    return (
      <React.Fragment>
        <Modal
          open={open}
          onClose={(_, reason) => {
            if (reason !== "backdropClick") {
              handleClose();
            }
          }}
        >
          <ModalBox sx={{ width: "60vw" }} title="Edit Prompt Scanner" handleClose={handleClose}>
            <Root>
              <CircularProgress color="primary" />
            </Root>
          </ModalBox>
        </Modal>
      </React.Fragment>
    );
  }
}

export default EditPromptScannerModal;
